"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  vertical-align: middle;\n  justify-content: center;\n\n  width: 40px;\n  height: 39px;\n  border-radius: 4px;\n  background-color: transparent;\n  border: 1px solid ", ";\n  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n\n  i {\n    color: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ActionButton = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.theme.palette.border.main;
}, function (props) {
  return props.theme.palette.text.main;
}, function (props) {
  return props.theme.palette.border.main;
});

var HelpButton = function HelpButton(_ref) {
  var dataElementLocation = _ref.dataElementLocation,
      dataElementLabel = _ref.dataElementLabel,
      dataElementId = _ref.dataElementId,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["dataElementLocation", "dataElementLabel", "dataElementId"]);
  return /*#__PURE__*/_react["default"].createElement(ActionButton, (0, _extends2["default"])({}, (0, _taggingHelper.getDataProperty)({
    dataElementType: _taggingHelper.DataElementTypes.BUTTON,
    dataElementLabel: dataElementLabel,
    dataElementId: dataElementId,
    dataElementLocation: dataElementLocation
  }), props), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "help"
  }));
};

HelpButton.propTypes = {
  dataElementLocation: _propTypes["default"].any.isRequired,
  dataElementLabel: _propTypes["default"].string.isRequired,
  dataElementId: _propTypes["default"].string.isRequired
};
var _default = HelpButton;
exports["default"] = _default;